import React, { useState } from 'react';
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import CheckIcon from '@mui/icons-material/Check';
import { useTranslation } from 'react-i18next';
import { useLocaleState } from 'react-admin';
import { LANG_STORAGE_KEY } from '../../core/i18n';

const LANGUAGES: { code: string; label: string }[] = [
  { code: 'pl', label: 'Polski' },
  { code: 'en', label: 'English' },
];

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [, setLocale] = useLocaleState();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const currentLang = i18n.language?.split('-')[0] ?? 'pl';

  const handleSelect = (code: string) => {
    try {
      localStorage.setItem(LANG_STORAGE_KEY, code);
    } catch {
      // localStorage unavailable — language just won't persist across refreshes
    }
    i18n.changeLanguage(code);
    setLocale(code);
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        aria-label="change language"
        aria-haspopup="true"
        aria-expanded={open}
        onClick={(e) => setAnchorEl(e.currentTarget)}
        sx={{
          color: 'var(--color-text-secondary)',
          borderRadius: 'var(--radius-md)',
          flexShrink: 0,
          '&:hover': { backgroundColor: 'var(--color-bg-subtle)' },
        }}
      >
        <LanguageOutlinedIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={() => setAnchorEl(null)}>
        {LANGUAGES.map(({ code, label }) => (
          <MenuItem key={code} selected={code === currentLang} onClick={() => handleSelect(code)}>
            <ListItemIcon>{code === currentLang && <CheckIcon fontSize="small" />}</ListItemIcon>
            <ListItemText>{label}</ListItemText>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default LanguageSwitcher;
